import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./index.css"
import GenAISidebar from "./GenAISidebar"
import GenAILibraryIndex from "./GenAILibraryIndex"

class GenAILibraryHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
        }
    }
  componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.openedContextMenuId !== this.state.openedContextMenuId) {
            this.setState({ openedContextMenuId: nextProps.openedContextMenuId })
        }
        if (nextProps && nextProps.customWidth !== this.state.customWidth) {
            this.setState({ customWidth: nextProps.customWidth })
        }
        if (nextProps && nextProps.customHeight !== this.state.customHeight) {
            this.setState({ customHeight: nextProps.customHeight })
        }
    }

    render() {
        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
          return (<div className="gen-ai-answering-container">
                <GenAISidebar customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
                <GenAILibraryIndex customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
            </div>)
        }
        else if (this.props.customWidth > 1000) {
            return (<div className="gen-ai-answering-container">
                <GenAISidebar customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
                <GenAILibraryIndex customWidth={this.state.customWidth} customHeight={this.state.customHeight} />
            </div>)
        }
    }

}
export default withRouter(GenAILibraryHome);